import { DatePipe } from '@angular/common';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { ModuleNames } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { DMSLogList } from '../../business-entities/dmsLogList-model';
import { DMSSyncFailedLogRequestModel, FeatureModel } from '../../business-entities/dmssyncfailedlog-request-model';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { DMSSyncFailedlogService } from '../../business-services/dms-sync-failed-log.service';
import { ExceptionViewComponent } from '../exception-view/exception-view.component';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { AddMechanicComponent } from '../mechanic/add-mechanic/add-mechanic.component';
import { AdminCommonService } from '../../services/admin-common.service';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-dms-syncfailedlog',
  templateUrl: './dms-syncfailedlog.component.html',
})
export class DmsSyncfailedlogComponent implements OnInit {
  userRoleRightsDetails: UserRoleMenu;
  integrationWithDMS: boolean = false;
  moduleId: number;
  dmsLogList: DMSLogList[] = [];
  featureList: FeatureModel[];
  bookingDate: any[] = [];
  todayViewDate: any;
  weekViewDate: any;
  isTodayViewOn: boolean = true;
  isWeekViewOn: boolean = false;
  popupCloseResult = false;
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  dmsLogRequestModel: DMSSyncFailedLogRequestModel =
    {
      startRecordNumber: 0,
      pageSize: 25,
      sortColumn: '',
      sortDirection: '',
      moduleId: 0,
      logDate: '',
      referenceId: 0
    };

  totalCount = 0;
  throttle = 100;
  scrollDistance = 1;
  _clientName: string;
  hideButtons: boolean = false;

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    public service: DMSSyncFailedlogService,
    private userService: UserDataService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private secureStorage: SecureStorage,
    private adminCommonSer :AdminCommonService

  ) {
  }

  async getFeatures() {
    let features = this.secureStorage.getKeyData('feature');
    if (features?.length > 0) {
      this.integrationWithDMS = features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
    }
  }

  async onFeatureSelect(modueId: number) {
    this.moduleId = modueId;
    if (modueId != undefined) {
      this.dmsLogRequestModel.moduleId = modueId;
    } else {
      this.dmsLogRequestModel.moduleId = 0;
    }
    this.dmsLogRequestModel.startRecordNumber = 0;
    this.dmsLogList = [];
    this.GetDMSLogList(this.dmsLogRequestModel)
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.dmsLogRequestModel.sortDirection = direction;
    this.dmsLogRequestModel.sortColumn = column;
    this.dmsLogRequestModel.startRecordNumber = 0;
    this.dmsLogList = [];
    this.GetDMSLogList(this.dmsLogRequestModel)
  }

  ngOnInit(): void {
    this._clientName = localStorage.getItem("Theme");
    this.hideButtons = this._clientName === 'mg';
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === ModuleNames.DMSSyncFailedlog);
    this.getFeatures();
    if (this.service.filterTypeId == 1) {
      this.loadTodayView();
    } else if (this.service.filterTypeId == 2) {
      this.loadWeekView();
    } else {
      this.loadTodayView();
    }
  }

  loadTodayView() {
    this.isTodayViewOn = true;
    this.isWeekViewOn = false;
    let todays_date = new Date();

    this.weekViewDate = this.datePipe.transform(todays_date, 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(todays_date, 'dd/MM/yyyy');
    this.bookingDate=[];
    this.bookingDate.push(todays_date);
    this.bookingDate.push(todays_date);
    this.todayViewDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    this.dmsLogRequestModel.logDate = this.todayViewDate;
    this.dmsLogRequestModel.startRecordNumber = 0;
    this.dmsLogList = [];
    this.GetDMSLogList(this.dmsLogRequestModel)
  }

  loadWeekView() {
    this.isTodayViewOn = false;
    this.isWeekViewOn = true;
    //Task 2235
    const  { weekViewDate, bookingDate } =this.adminCommonSer.getWeekViewDatesNew(1);
    this.bookingDate = [...bookingDate];
    this.dmsLogRequestModel.logDate = weekViewDate;
    this.dmsLogList = [];
    this.GetDMSLogList(this.dmsLogRequestModel);
  }

  onDateRangeChanged(event: any) {
    this.bookingDate = (typeof event === 'undefined') ? [] : event;
    this.dmsLogRequestModel.startRecordNumber = 0;
    this.dmsLogList = [];
    this.GetDMSLogList(this.dmsLogRequestModel);
  }

  onClickChangeView(isWeek: boolean) {
    if (isWeek) {
      this.loadWeekView()
    } else {
      this.loadTodayView()
    }
  }


  refresh() {
    this.dmsLogRequestModel.startRecordNumber = 0;
    this.dmsLogList = [];
    this.GetDMSLogList(this.dmsLogRequestModel);
  }

  monthDiff(d1: any, d2: any) {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth();
    // edit: increment months if d2 comes later in its month than d1 in its month
    if (d2.getDate() >= d1.getDate())
      months++
    // end edit
    return months <= 0 ? 0 : months;
  }

  onScrollDown(_ev) {
    if(this.totalCount > this.dmsLogList.length){
      this.dmsLogRequestModel.startRecordNumber = this.dmsLogList.length;
      this.GetDMSLogList(this.dmsLogRequestModel);
    }
  }

  GetDMSLogList(dmsLogRequestModel: DMSSyncFailedLogRequestModel) {
      let bookingDateFormatted= this.getFormattedDate(this.bookingDate);
      let startDate = new Date(this.datePipe.transform(this.bookingDate[0], 'MM/dd/yyyy'));
      let endDate = new Date(this.datePipe.transform(this.bookingDate[1], 'MM/dd/yyyy'));
      if (this.monthDiff(startDate, endDate) >= 3) {
        let addedMsg = this.translate.instant('lbldaterangeForThreeMonths');
        this.toastr.warning(addedMsg);
        return;
      }
      this.dmsLogRequestModel.logDate = bookingDateFormatted;

    this.spinner.show();

    this.service.GetDmsSyncFailedLog(dmsLogRequestModel).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.dmsLogList.push(...this.DMSLogDataMapper(response.responseObject));
        this.totalCount = this.dmsLogList.length > 0 ? this.dmsLogList[0].totalCount : 0;
        this.featureList = [];
        if (this.dmsLogList.length > 0) {
          this.dmsLogList.forEach(element=>{
            if (this.featureList.findIndex(f => f.id == element.moduleId) == -1) {
              let s = Object();
              s.id = element.moduleId;
              s.name = element.moduleName;
              this.featureList.push(s)
            }
          })
        }
        this.spinner.hide();
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.MechanicCode) {
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
  }

  private DMSLogDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {

      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.rowNumber = this.dmsLogRequestModel.startRecordNumber + 1 + index;
        single.rowId = element.rowId;
        single.methodName = element.methodName;
        single.moduleName = element.moduleName;
        single.apiUrl = element.apiUrl;
        single.methodType = element.methodType;
        single.headerName = element.headerName;
        single.headerValue = element.headerValue;
        single.requestJson = element.requestJson;
        single.responseStatusCode = (element.responseStatusCode == "OK" || element.responseStatusCode == "0")? "Error" : element.responseStatusCode;
        single.exceptionMessage = element.exceptionMessage;
        single.syncStatus = element.syncStatus;
        single.syncDate = element.syncDate;
        single.createdBy = element.createdBy;
        single.moduleId = element.moduleId;
        single.referenceName = element.referenceName;
        single.referenceId = element.referenceId;
        single.createdByName = element.createdByName;
        single.createDate = Utility.ConvertUTCDateToLocalDate(new Date(element.createDate+"Z")) ;
        single.environment = element.environment;
        single.errorFrom = element.errorFrom;
        single.syncLog = element.syncLog;
        single.totalCount = element.totalCount;
        supperArray.push(single);


      }
    }
    return supperArray;
  }

  ngOnDestroy(): void {
    this.service.filterTypeId = 0;
  }

  private getDismissDeleteReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  viewException(result){
    let modelHeadermsg="";
    if(result.syncStatus == 1){
     modelHeadermsg = this.translate.instant("lblSyncLog");
     result.responseStatusCode = "Success";
    }
    else{
      modelHeadermsg = this.translate.instant("lblSyncErrorLog");
      result.responseStatusCode = "Error";
    }
    const modalRef = this.modalService.open(ExceptionViewComponent, {size: 'lg'});
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.dmsLogList = result;
    modalRef.componentInstance.integrationWithDMS = this.integrationWithDMS;
    modalRef.result.then((_result) => {
      // This is intentional
     }, (reason) => {
      this.popupCloseResult = this.getDismissDeleteReason(reason);

    });
  }
  
  onSyncToDms(moduleId, id, name) {
    const log = this.dmsLogList.find(x =>x.referenceId == id);
    this.service.onSyncToDms(moduleId, id, name,this.dmsLogRequestModel,log?.environment);
  }
  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}
